module.exports = __webpack_public_path__ + "img/0-l.5ea06e98.png";